import { useEffect, useState } from 'react';
import { fetchWorkspacesList } from '../../api/access';

// Cache em nível de módulo: várias células/popovers da planilha pedem "todas
// as áreas da org" ao mesmo tempo; sem isso cada abertura de popover dispara
// um novo GET /workspaces (mesma classe de problema do polling de BUG-01,
// .claude/rbac/arquitetura-v2.md §5.5).
let cache = null;
let inflight = null;

export default function useAllWorkspaces() {
  const [workspaces, setWorkspaces] = useState(cache || []);
  const [loading, setLoading] = useState(!cache);

  useEffect(() => {
    if (cache) {
      setWorkspaces(cache);
      setLoading(false);
      return undefined;
    }
    if (!inflight) {
      inflight = fetchWorkspacesList()
        .then((data) => {
          cache = Array.isArray(data) ? data : [];
          return cache;
        })
        .catch((err) => {
          inflight = null;
          throw err;
        });
    }
    let alive = true;
    inflight
      .then((data) => {
        if (alive) {
          setWorkspaces(data);
          setLoading(false);
        }
      })
      .catch(() => {
        if (alive) setLoading(false);
      });
    return () => {
      alive = false;
    };
  }, []);

  return { workspaces, loading };
}
